import { SecurityDataFragment, SecurityDataType } from '@/types/service-response'

export class SecurityData {
  private constructor (
    readonly area: string,
    readonly component: string,
    readonly visibility: boolean,
    readonly enabled: boolean

  ) {}

  static createFromResponse (responseData: SecurityDataType): Array<SecurityData> {
    return responseData.map((item: SecurityDataFragment) => {

      return new SecurityData(
        item.area,
        item.component,
        item.visibility,
        item.enabled
      )
    })
  }
}
